// Thin client for the shop API (backend/shop.py). REACT_APP_BACKEND_URL is set
// in Render for production; locally point it at uvicorn (see README).
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

async function request(path, options = {}) {
  if (!API_URL) throw new Error('Shop API is not configured (REACT_APP_BACKEND_URL).');
  const res = await fetch(`${API_URL}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* empty body */
  }
  if (!res.ok) {
    const detail = (data && (data.detail || data.message)) || `Request failed (${res.status})`;
    const err = new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
    err.status = res.status;
    throw err;
  }
  return data;
}

export function fetchAvailability() {
  return request('/api/shop/availability');
}

export function createCheckout(payload) {
  return request('/api/shop/checkout', { method: 'POST', body: JSON.stringify(payload) });
}

export function fetchOrderSummary(orderNo, params = {}) {
  const qs = new URLSearchParams(params).toString();
  return request(`/api/shop/session/${encodeURIComponent(orderNo)}${qs ? `?${qs}` : ''}`);
}

// Door photos after payment: the order's photoToken (from the success page's summary or the
// confirmation email link) is the only key. Both calls answer for install orders only.
export function fetchOrderPhotos(orderNo, token) {
  return request(`/api/shop/orders/${encodeURIComponent(orderNo)}/photos?t=${encodeURIComponent(token)}`);
}

export function uploadOrderPhotos(orderNo, token, photos, backsetMeasuredMm = null) {
  return request(`/api/shop/orders/${encodeURIComponent(orderNo)}/photos`, {
    method: 'POST',
    body: JSON.stringify({ token, backsetMeasuredMm, photos: photos.map((p) => ({ filename: p.name, contentType: p.type, data: p.data })) }),
  });
}

export function adminListOrders(token) {
  return request('/api/shop/orders', { headers: { Authorization: `Bearer ${token}` } });
}

export function adminUpdateOrder(token, orderNo, body) {
  return request(`/api/shop/orders/${encodeURIComponent(orderNo)}/status`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
}

// PostHog is loaded by public/index.html; events are a no-op elsewhere.
export function track(event, props) {
  try {
    if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(event, props || {});
  } catch {
    /* analytics must never break the shop */
  }
}

export { API_URL };
